import { withLocalePrefix } from 'shared/utils/translation';
import { AppliedOnType } from 'talent_matching/types';

const t = withLocalePrefix('talent_matching.filters.applied');

const APPLIED_ON_TYPES_WIHOUT_DATES: AppliedOnType[] = [
  AppliedOnType.TODAY,
  AppliedOnType.YESTERDAY,
  AppliedOnType.LAST_SEVEN_DAYS,
  AppliedOnType.LAST_6_MONTHS,
  AppliedOnType.LAST_12_MONTHS,
  AppliedOnType.LAST_2_YEARS,
];

const APPLIED_ON_TEXT_MAPPING: {
  [key in AppliedOnType]: (start: string, end: string) => string;
} = {
  [AppliedOnType.TODAY]: () => t('today'),
  [AppliedOnType.YESTERDAY]: () => t('yesterday'),
  [AppliedOnType.LAST_SEVEN_DAYS]: () => t('last_seven_days'),
  [AppliedOnType.LAST_6_MONTHS]: () => t('last_6_months'),
  [AppliedOnType.LAST_12_MONTHS]: () => t('last_12_months'),
  [AppliedOnType.LAST_2_YEARS]: () => t('last_2_years'),
  [AppliedOnType.BETWEEN]: (start, end) => t('between', { start, end }),
  [AppliedOnType.ON_OR_AFTER]: (start) => t('on_or_after', { start }),
  [AppliedOnType.ON_OR_BEFORE]: (_start, end) => t('on_or_before', { end }),
};

const isAppliedOnFiltered = ({
  appliedOnType,
  appliedOnStart,
  appliedOnEnd,
}: {
  appliedOnType?: AppliedOnType | null;
  appliedOnStart?: string | null;
  appliedOnEnd?: string | null;
}) => {
  return (
    appliedOnType &&
    (appliedOnStart ||
      appliedOnEnd ||
      APPLIED_ON_TYPES_WIHOUT_DATES.includes(appliedOnType))
  );
};

export { APPLIED_ON_TEXT_MAPPING, isAppliedOnFiltered };
